import enCommon from "./locales/en/common.json" with { type: "json" };
import enZod from "./locales/en/zod.json" with { type: "json" };
import esCommon from "./locales/es/common.json" with { type: "json" };
import esZod from "./locales/es/zod.json" with { type: "json" };
import ptCommon from "./locales/pt/common.json" with { type: "json" };
import ptZod from "./locales/pt/zod.json" with { type: "json" };
import frCommon from "./locales/fr/common.json" with { type: "json" };
import frZod from "./locales/fr/zod.json" with { type: "json" };
import deCommon from "./locales/de/common.json" with { type: "json" };
import deZod from "./locales/de/zod.json" with { type: "json" };
import itCommon from "./locales/it/common.json" with { type: "json" };
import itZod from "./locales/it/zod.json" with { type: "json" };
import nlCommon from "./locales/nl/common.json" with { type: "json" };
import nlZod from "./locales/nl/zod.json" with { type: "json" };
import jaCommon from "./locales/ja/common.json" with { type: "json" };
import jaZod from "./locales/ja/zod.json" with { type: "json" };
import koCommon from "./locales/ko/common.json" with { type: "json" };
import koZod from "./locales/ko/zod.json" with { type: "json" };
import trCommon from "./locales/tr/common.json" with { type: "json" };
import trZod from "./locales/tr/zod.json" with { type: "json" };
import daCommon from "./locales/da/common.json" with { type: "json" };
import daZod from "./locales/da/zod.json" with { type: "json" };
import hiCommon from "./locales/hi/common.json" with { type: "json" };
import hiZod from "./locales/hi/zod.json" with { type: "json" };
import arCommon from "./locales/ar/common.json" with { type: "json" };
import arZod from "./locales/ar/zod.json" with { type: "json" };
import zhHKCommon from "./locales/zh-HK/common.json" with { type: "json" };
import zhHKZod from "./locales/zh-HK/zod.json" with { type: "json" };
import zhCNCommon from "./locales/zh-CN/common.json" with { type: "json" };
import zhCNZod from "./locales/zh-CN/zod.json" with { type: "json" };
const RESOURCES = {
  en: {
    common: enCommon,
    zod: enZod
  },
  es: {
    common: esCommon,
    zod: esZod
  },
  pt: {
    common: ptCommon,
    zod: ptZod
  },
  fr: {
    common: frCommon,
    zod: frZod
  },
  de: {
    common: deCommon,
    zod: deZod
  },
  it: {
    common: itCommon,
    zod: itZod
  },
  nl: {
    common: nlCommon,
    zod: nlZod
  },
  ja: {
    common: jaCommon,
    zod: jaZod
  },
  ko: {
    common: koCommon,
    zod: koZod
  },
  tr: {
    common: trCommon,
    zod: trZod
  },
  da: {
    common: daCommon,
    zod: daZod
  },
  hi: {
    common: hiCommon,
    zod: hiZod
  },
  ar: {
    common: arCommon,
    zod: arZod
  },
  "zh-HK": {
    common: zhHKCommon,
    zod: zhHKZod
  },
  "zh-CN": {
    common: zhCNCommon,
    zod: zhCNZod
  }
};
export {
  RESOURCES
};
//# sourceMappingURL=resources.js.map